import { Helmet } from "react-helmet";
import { Heading, Img, Button, Text } from "../../components";
import CarCard from "../../components/CarCard";
import UserProfile1 from "../../components/UserProfile1";
import React, {
  Suspense,
  useEffect,
  useState,
  useCallback,
} from "react";
import useInfiniteScroll from "components/UseInfiniteScroll"; // ✱ NEW
import RightSideMenuProvider from "components/RightSideMenuProvider";
import MyAdsProvider from "components/MyAdsProvider";
import OfferFilterBar from "components/OfferFilterBar";
import FilterBar from "components/FilterBar";
import OfferCard from "components/OfferCard";
//import TestFile1AfterRow from "components/TestFile1AfterRow";
import AllCarsLines from "components/TestFile1AfterRow";
import axios from "axios";
import {API_DOMAIN_IMG, API_DOMAIN} from 'config';
import useDisplayMode from "useDisplayMode";

import { useLocation } from 'react-router-dom';
import OffersDealerTable from 'components/OffersDealerTable'
import SendNewOfferPopup from "components/SendNewOfferPopup";
import { JoyrideTour, isOnboardingStateSyncReady, isTourDone, offersTourSteps, useTour } from "../../onboarding";
import { isApprovedAuctionOffer } from "utils/auctionFlags";
const AUCTION_APPROVED_TAB = "הצעות שזכו במכרז";
const tabs = [
   "כל ההצעות",
  "הצעות שנדחו",  
  "הצעות שאושרו",

   AUCTION_APPROVED_TAB,
  "הצעות ממתינות לאישור",
];
// MyOffersDealer.jsx (למעלה בקובץ)
const OFFER_STATUS = {
  [AUCTION_APPROVED_TAB]: 2,
  "כל ההצעות":           null, // null = ללא סינון
  "הצעות ממתינות לאישור": 1,
  "הצעות שאושרו":        2,
  "הצעות שנדחו":         3,
};

export default function OffersDealer({currentUser, setDealerCounters}) {
  const location = useLocation();
  const {
    endTour,
    isManualTour,
    runOffersTour,
    setStepIndex,
    startOffersTour,
    stepIndex,
  } = useTour();
  const hasStartedOffersTourRef = React.useRef(false);

  /* ---------- UI state ---------- */
  const [activeTab, setActiveTab] = useState(location.state?.defaultTab ?? 'הצעות ממתינות לאישור');
  const [filters, setFilters] = useState({});
  const [displayMode, setDisplayMode] = useDisplayMode();
  const [offers, setOffers] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showSendNewOfferPopup, setShowSendNewOfferPopup] = useState(false);
  const [selectedBid, setSelectedBid] = useState(null);
const [initialLoaded, setInitialLoaded] = useState(false);
  const latestOffersRequestRef = React.useRef(0);

  const PAGE_SIZE = 5;

  /* ---------- infinite-scroll hook ---------- */
const sentinelRef = useInfiniteScroll(() => {
  if (!initialLoaded) return;        // ⬅️ חכה לעמוד 1
  if (!loading && hasMore) setPage((p) => p + 1);
});
  /* ---------- fetchOffers ---------- */
const fetchOffers = useCallback(
  async (pageToLoad = 1, reset = false) => {
    if (!currentUser?.id) return;

      const requestId = latestOffersRequestRef.current + 1;
      latestOffersRequestRef.current = requestId;

 
      const status = OFFER_STATUS[activeTab];
      const isAuctionApprovedTab = activeTab === AUCTION_APPROVED_TAB;
      const params = {
        ...filters,
        userId: currentUser.id,
        page: pageToLoad,
        pageSize: PAGE_SIZE,
      };
      if (status !== null) params.offerStatus = status;
      if (isAuctionApprovedTab) params.auctionOnly = 1;

      setLoading(true);
      try {
      const { data } = await axios.get(`${API_DOMAIN}/offer/filterOffers`, { params });
      if (requestId !== latestOffersRequestRef.current) return;
      const nextData = isAuctionApprovedTab ? data.filter(isApprovedAuctionOffer) : data;
      setOffers((prev) => (reset ? nextData : [...prev, ...nextData]));
      setHasMore(data.length === PAGE_SIZE);

      // ➟ ברגע שהדף הראשון נגמר לטעון – אפשר להתחיל אינסוף-גלילה
      if (pageToLoad === 1) setInitialLoaded(true);

    } catch (err) {
      if (requestId !== latestOffersRequestRef.current) return;
      console.error('fetchOffers', err);
    } finally {
      if (requestId === latestOffersRequestRef.current) {
        setLoading(false);
      }
    }
  },
  [filters, activeTab, currentUser?.id]
);

  /* ---------- counters ---------- */
  async function loadCounters() {

    
    if (!currentUser?.id) return;
    const base = { userId: currentUser.id, count_only: 1 };
    const all = await axios.get(`${API_DOMAIN}/offer/filterOffers`, { params: base }).then((r) => r.data.total ?? 0);
    const pending = await axios
      .get(`${API_DOMAIN}/offer/filterOffers`, { params: { ...base, offerStatus: 1 } })
      .then((r) => r.data.total ?? 0);
    const approved = await axios
      .get(`${API_DOMAIN}/offer/filterOffers`, { params: { ...base, offerStatus: 2 } })
      .then((r) => r.data.total ?? 0);
    const rejected = await axios
      .get(`${API_DOMAIN}/offer/filterOffers`, { params: { ...base, offerStatus: 3 } })
      .then((r) => r.data.total ?? 0);
setDealerCounters(prev => ({
  ...prev,
  offers_all:      all,
  offers_new:      pending,
  offers_approved: approved,
  offers_rejected: rejected,
}));
  }

/* ---------- effects ---------- */
  useEffect(() => {
    fetchOffers(page, page === 1);
  }, [fetchOffers, page]);

  useEffect(() => {
    setInitialLoaded(false);
    setOffers([]);
    setHasMore(true);
    setPage(1); // reset עמוד כשמחליפים פילטר/טאב
  }, [filters, activeTab]);

useEffect(() => {
  loadCounters();
  const t = setInterval(loadCounters, 120000);
  return () => clearInterval(t);
}, [currentUser?.id]);

const hasOffers = offers.length > 0;
const onboardingSyncReady = isOnboardingStateSyncReady(currentUser?.id);
const isManualOffersTour = isManualTour("offers");
const canRunOffersTour =
  runOffersTour &&
  onboardingSyncReady &&
  initialLoaded &&
  !loading &&
  hasOffers &&
  (isManualOffersTour || !isTourDone("offers", currentUser?.id));

useEffect(() => {
  if (hasStartedOffersTourRef.current) return;
  if (currentUser?.user_type !== 3) return;
  if (!onboardingSyncReady) return;
  if (!initialLoaded || loading || !hasOffers) return;
  if (isTourDone("offers", currentUser?.id)) return;

  hasStartedOffersTourRef.current = true;
  startOffersTour();
}, [currentUser?.id, currentUser?.user_type, hasOffers, initialLoaded, loading, onboardingSyncReady, startOffersTour]);

/* ---------- auto-refresh: עמוד 1 כל 120 שניות ---------- */
useEffect(() => {
  const refresh = async () => {
    setInitialLoaded(false);   // חוסם אינסוף-גלילה בזמן הטעינה
    setPage(1);                // מאפס מונה-עמודים
    await fetchOffers(1, true); // מביא מחדש את עמוד-הראשון (reset=true)
    loadCounters();            // מעדכן את המונים בראש הדף
  };

  const t = setInterval(refresh, 120_000); // כל 2 דקות
  return () => clearInterval(t);           // ניקוי עם unmount
}, [fetchOffers, currentUser?.id]);  // בהקשר הנוכחי

return (
    <>
      <JoyrideTour
        run={canRunOffersTour}
        steps={offersTourSteps}
        stepIndex={stepIndex}
        tourName="offers"
        onEnd={(status) => endTour("offers", undefined, status)}
        onStepChange={setStepIndex}
      />

      <div className="offers-dealer flex bg-blue_gray-50 p-8 sm:p-4" style={{paddingTop: '1.2rem'}}>
        <div className="w-[100%] items-start gap-4 md:flex-col" style={{gap: '2%'}}>
         
          <div className="main-section flex relative flex-1 flex-col gap-8 self-center rounded-[24px] bg-secondary-primary_white p-6 md:self-stretch sm:p-4" style={{ minHeight: "95.5vh" }}>
          <header className="flex flex-col items-start gap-3">
          <div
  className="w-[15%] ml-3 absolute top-0 left-0 h-8 ] 
             flex items-center justify-center gap-4 
             rounded-br-[10px] md:px-5 crumbs"
>

                         <div className=" flex w-full justify-center gap-1">
                           <Heading size="headinglg" as="h2" className="text-[12px] font-bold !text-gray-900_04">
                             <span className="text-gray-900_04">&nbsp;</span>
                             <span className="font-heebo font-medium text-gray-600">ההצעות שלי</span>
                           </Heading>
                           <Img src="images/img_signal_red_a700_03_16x16.svg" alt="Signal" className="h-[16px]" />
                         </div>
                         <div className="flex w-full items-center justify-center">
                           <Heading size="textxs" as="h3" className="!font-heebo text-[12px] font-medium !text-gray-600">
                            סוחר
                           </Heading>
                           <Img src="images/img_vector_deep_orange_500.svg" alt="Image" className="h-[16px]" />
                         </div>
                       </div>
              <div className="flex items-center justify-between gap-5 mt-5 self-stretch md:flex-col">
                <div className="flex justify-center gap-3.5 md:w-full hide-mobile">
                  <Img src="images/img_button1_gray_100_01.svg" alt="Buttonone"     onClick={() => setDisplayMode("cards")}
  className="h-[32px] rounded-[10px] cursor-pointer"
 />
                <Img
                  src="images/3lines.svg"
                  alt="Buttonone"
                  onClick={() => setDisplayMode("lines")}
                  className="h-[32px] rounded-[10px] cursor-pointer"
                />
                </div>
             {/* במקום ה־div הישן */}
       <div className="offers-tabs flex justify-center  xs-flex-row-reverse md:flex-row  border-b border-solid border-gray-200 " data-testid="offers-tabs">
  {tabs.map(tab => (
    <div
      key={tab}
      onClick={() => setActiveTab(tab)}
      className={`
        px-4 py-2
        cursor-pointer
        text-center
        ${activeTab === tab
          ? "border-b border-red-a700_03 text-black"
          : "text-gray-600"
        }
      `}
    >
      {tab}
    </div>
  ))}
</div>

                <div className="flex gap-3">
                  <Heading size="heading9xl" as="h4" className="!font-heebo text-[25px] font-bold lg:text-[21px]">
                   ההצעות שלי
                  </Heading>
                  <Img src="/images/img_user_red_a700_03_1.svg" alt="Car" className="icon-mobile-offer h-[28px]" />
                </div>
              </div>
            </header>
            <div className="flex flex-col gap-6">
            <FilterBar onChange={setFilters} />


 <div
   className="grid grid-cols-4 gap-5 gap-y-5 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1"
   dir="rtl"
   style={{ direction: "rtl" }}
 >
                <Suspense fallback={<div>Loading feed...</div>}>
                  {displayMode === 'cards' && !loading && offers.length === 0 && (
                    <div className="col-span-4 flex items-center justify-center" style={{ minHeight: "50vh" }}>
                      <div className="rounded-[16px] border border-gray-200 bg-white px-10 py-8 flex items-center gap-6">
                        <div className="flex flex-col items-center text-center gap-2" style={{ direction: "rtl" }}>
                          <Img src="/images/img_user_red_a700_03_1.svg" alt="offers" className="h-[28px] w-[28px]" />
                          <Heading as="h3" className="!font-assistant text-[16px] font-medium !text-gray-900_04">
                            אין הצעות להצגה
                          </Heading>
                          <Heading as="h3" className="!font-assistant text-[14px] font-normal !text-gray-500">
                            נסה לשנות את הפילטרים או הטאב
                          </Heading>
                        </div>
                      </div>
                    </div>
                  )}
                  {displayMode === 'cards' &&
                    offers.map((offer) => (
                      <OfferCard
                        key={offer?.offer_id}
                        {...offer}
                        images={offer.images}
                        currentUser={currentUser}
                        isDealer
                        onOfferClick={() => {
                          setSelectedBid(offer);
                          setShowSendNewOfferPopup(true);
                        }}
                      />
                    ))}
                </Suspense>
              </div>

              {/* --- Table view --- */}
              {displayMode === 'lines' && !loading && offers.length === 0 && (
                <div className="flex items-center justify-center" style={{ minHeight: "50vh" }}>
                  <div className="rounded-[16px] border border-gray-200 bg-white px-10 py-8 flex items-center gap-6">
                    <div className="flex flex-col items-center text-center gap-2" style={{ direction: "rtl" }}>
                      <Img src="/images/img_user_red_a700_03_1.svg" alt="offers" className="h-[28px] w-[28px]" />
                      <Heading as="h3" className="!font-assistant text-[16px] font-medium !text-gray-900_04">
                        אין הצעות להצגה
                      </Heading>
                      <Heading as="h3" className="!font-assistant text-[14px] font-normal !text-gray-500">
                        נסה לשנות את הפילטרים או הטאב
                      </Heading>
                    </div>
                  </div>
                </div>
              )}
              {displayMode === 'lines' &&
                offers.map((offer) => (
                  <OffersDealerTable
                    key={offer?.offer_id}
                    offer={offer}
                    car={offer}
                    images={offer.images}
                    isDealer
                    offer_status={offer.status}
                    onOfferClick={() => {
                      setSelectedBid(offer);
                      setShowSendNewOfferPopup(true);
                    }}
                  />
                ))}

              {/* Sentinel תמיד מחוץ ל-Suspense לשם יציבות */}
              <div ref={sentinelRef} style={{ height: 1 }} />
            </div>
          </div>
        </div>
      </div>

      {/* --- Popup --- */}
      {showSendNewOfferPopup && selectedBid && (
     <SendNewOfferPopup
  car={selectedBid}
  offer={selectedBid}
  currentUser={currentUser}
  onUpdateOffer={(upd) => {
    setOffers(prev => {
      const uid = Number(upd?.offer_id ?? upd?.id);
      let found = false;
      const next = prev.map(o => {
        const oid = Number(o?.offer_id ?? o?.id);
        if (oid === uid) {
          found = true;
          return {
            ...o,
            ...upd,
            // הבטחה שהשדות החשובים עודכנו
            offered_price: upd.offered_price ?? o.offered_price,
            offer_status:  upd.offer_status  ?? o.offer_status,
            collection_date: upd.collection_date ?? o.collection_date,
            last_payment_date: upd.last_payment_date ?? o.last_payment_date,
            is_reserved: upd.is_reserved ?? o.is_reserved,
          };
        }
        return o;
      });
      // אם משום מה לא נמצא – הוספה (לא חובה)
      return found ? next : [upd, ...next];
    });
  }}
  onClose={() => setShowSendNewOfferPopup(false)}
/>

      )}
    </>
  );
}
